export const getCoworkerCategory = (config, name) => {
  const categories = config.kcFilteringOptions || [];
  return categories.find(item => item.nameIdentifier === name);
};
